import { Controller } from "@hotwired/stimulus";

// Subscribes to all `calendar:*` CustomEvents emitted by any descendant calendar
// and appends a timestamped row per event into the list target.
//
// Mount this controller on a wrapper that contains both the calendar and the log:
//
//   <div data-controller="calendar-event-log">
//     <div data-calendar-root="true">...</div>
//     <ul data-calendar-event-log-target="list"></ul>
//   </div>
const EVENT_NAMES = [
  "data-loaded",
  "data-error",
  "view-change",
  "date-change",
  "slot-click",
  "event-click",
  "event-move",
  "event-resize",
];

export default class extends Controller {
  static targets = ["list"];

  connect() {
    this._handlers = EVENT_NAMES.map((name) => {
      const handler = (event) => this._append(name, event.detail);
      this.element.addEventListener(`calendar:${name}`, handler);
      return [name, handler];
    });
  }

  disconnect() {
    this._handlers.forEach(([name, handler]) =>
      this.element.removeEventListener(`calendar:${name}`, handler)
    );
    this._handlers = [];
  }

  _append(name, detail) {
    if (!this.hasListTarget) return;

    // First real event clears the placeholder.
    const first = this.listTarget.firstElementChild;
    if (first?.dataset?.placeholder === "true") {
      first.remove();
    }

    const li = document.createElement("li");
    li.className = "py-1 border-b border-gray-100 last:border-b-0";

    const ts = document.createElement("span");
    ts.className = "text-gray-400 mr-2";
    ts.textContent = new Date().toLocaleTimeString("en-US", { hour12: false });

    const evName = document.createElement("span");
    evName.className = "font-bold text-black mr-2";
    evName.textContent = name;

    const payload = document.createElement("span");
    payload.className = "text-gray-700 break-all";
    payload.textContent = this._stringifyDetail(detail);

    li.append(ts, evName, payload);
    this.listTarget.appendChild(li);
    this.listTarget.scrollTop = this.listTarget.scrollHeight;
  }

  _stringifyDetail(detail) {
    try {
      return JSON.stringify(detail);
    } catch {
      return "[unserializable detail]";
    }
  }
}
